import { faSearchDollar } from "@fortawesome/free-solid-svg-icons";
export const assetMeasureSelection = {
    name: "Asset Measure Selection",
    minSize: [5, 1],
    icon: faSearchDollar,
    description: "Choose asset measure(s)",
    defaultConfig: {
        defaultValue: null,
        key: "Asset Measure",
    },
    type: "input",
    category: "dashboard",
};
